import * as config from "./configs/sandbox.js";
export default config;
